class Dialog {
  static confirm({
    text = '',
    confirmText = '',
    cancelText = '',
    onConfirm = undefined,
    onCancel = undefined,
  } = {}) {
    let resolveFn, rejectFn;
    const usePromise = typeof onConfirm !== 'function' && typeof onCancel !== 'function';
    let promise;
    if (usePromise) {
      promise = new Promise((resolve, reject) => {
        resolveFn = resolve;
        rejectFn = reject;
      });
    }

    // 遮罩
    const mask = document.createElement('div');
    mask.className = 'liquid-dialog-mask';

    // 弹窗
    const dialog = document.createElement('div');
    dialog.className = 'liquid-dialog';

    // 关闭按钮
    const closeBtn = document.createElement('button');
    closeBtn.className = 'liquid-dialog-close';
    closeBtn.innerHTML = '&times;';
    closeBtn.onclick = close;
    dialog.appendChild(closeBtn);

    // 内容
    const content = document.createElement('div');
    content.className = 'liquid-dialog-content';
    content.innerHTML = text;
    dialog.appendChild(content);

    // 按钮区
    const footer = document.createElement('div');
    footer.className = 'liquid-dialog-footer';

    if (!!cancelText) {
      const cancelBtn = document.createElement('button');
      cancelBtn.className = 'cart__checkout-button button liquid-dialog-cancel';
      cancelBtn.innerText = cancelText;
      cancelBtn.onclick = () => {
        close();
        if (usePromise) {
          rejectFn && rejectFn();
        } else if (typeof onCancel === 'function') {
          onCancel();
        }
      };
      footer.appendChild(cancelBtn);
    }

    if (!!confirmText) {
      const confirmBtn = document.createElement('button');
      confirmBtn.className = 'cart__checkout-button button liquid-dialog-confirm';
      confirmBtn.innerText = confirmText;
      confirmBtn.onclick = () => {
        close();
        if (usePromise) {
          resolveFn && resolveFn();
        } else if (typeof onConfirm === 'function') {
          onConfirm();
        }
      };
      footer.appendChild(confirmBtn);
    }

    dialog.appendChild(footer);
    document.body.appendChild(mask);
    mask.appendChild(dialog);

    // 禁止页面滚动
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    function close() {
      dialog.classList.add('hide');
      mask.classList.add('hide');
      setTimeout(() => {
        dialog.remove();
        mask.remove();
        // 恢复页面滚动
        document.body.style.overflow = originalOverflow;
      }, 200);
    }

    if (usePromise) {
      return promise;
    }
  }
} 